<template>
    <div class="subscription-popup">
        <div class="subscription-popup-content">
            <div class="subscription-popup-content-header">
                <div class="cross" @click="closePopup()">
                    <img src="@/assets/images/close.svg" alt="Cross" />
                </div>
            </div>
            <b-overlay
            :show="loading"
            spinner-variant="primary"
            spinner-type="grow"
            spinner-small
            rounded="sm"
            >
            <b-row class="subscription-row">
                <SubscriptionPopupContent :current_subscription="current_subscription" :subscriptions="subscriptions" :current_user_id="current_user_id" />
                
            </b-row>
            </b-overlay>
        </div>
    </div>
  </template>
  
  <script>
  import {BModal, BButton, BOverlay, BRow, BCol, VBModal, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
  import {APIRequest} from '@simb2s/senseye-sdk'
  import { VueGoodTable } from 'vue-good-table'
  import SubscriptionPopupContent from './popup/SubscribtionPopupContent.vue'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  
  export default {
    components: {
      BCard,
      BCardText,
      VueGoodTable,
      BAvatar,
      BBadge,
      BPagination,
      BFormGroup,
      BFormInput,
      BFormSelect,
      BDropdown,
      BDropdownItem,
      BOverlay,
      BModal,
      BButton,
      BRow,
      BCol,
      SubscriptionPopupContent
    },
    props:['current_user_id'],
    data() {
      return {
       
        subscriptions:[],
      
        totalRows:0,
        current_subscription:null,
        currentPage:1,
       
        loading:true,
        
  
      }
    },
    watch:{
      
    },
    methods:{
      closePopup()
      {
        this.$emit('close')
      }
     
    },
    async mounted()
    {
     
        let subscriptions=await APIRequest.list('subscription-types')
        this.subscriptions=subscriptions[0]
        this.totalRows=subscriptions[1]
    
     
        this.loading=false
     
    }
  }
  </script>
  
  <style lang="scss" scoped>
  @import '@core/scss/vue/libs/vue-good-table.scss';
  
  .plan-header
  {
    display:flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  .plan-col
  {
    padding:20px;
    background:#f1f1f1;
    border-radius:5px;
   
  }
  .subscription-popup-content
  {
    overflow: auto;
    width:calc(100% - 40px) ;
    height:calc(100% - 40px);
    background-color: #fff;
    border-radius: 5px;
    padding: 20px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .subscription-popup
  {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 10000;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
  }
.subscription-popup-content-header
{
    position:absolute;
    top:0;
    z-index: 2;
    left:2%;
    width:98%;
    height:80px;
    border-bottom: 1px solid #f1f1f1;
}
.cross
{
    cursor: pointer;
    position:absolute;
    top:20px;
    right:20px;
    width:40px;
    height:40px;
    background:#f1f1f1;
    border-radius:5px;
    display:flex;
    align-items: center;
    justify-content: center;
    img{
        width:12px;
    }
}
  </style>
  